import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const BANNER = 'https://x0.ifengimg.com/ucms/2026_44/77D656037EAE1ECCBEFC5F1C66571851A60CCD28_size198_w750_h440.png';
const pad2 = value => String(value).padStart(2, '0');

const BannerArt = ({ isMarginTop = false }) => {
    const now = new Date();
    const month = pad2(now.getMonth() + 1);
    const day = pad2(now.getDate());

    return (
        <div className={styles.bannerBox} >
            <div className={`${styles.banner} ${isMarginTop ? styles.marginTop : ''}`}>
                <img className={styles.image} src={BANNER} alt="" crossOrigin="anonymous" />
                <div className={styles.date}>
                    {month.split('').map((digit, index) => (
                        <span className={styles.monthDigit} key={`month-${index}`}>
                            {digit}
                        </span>
                    ))}
                    <span className={styles.unit}>月</span>
                    {day.split('').map((digit, index) => (
                        <span className={styles.dayDigit} key={`day-${index}`}>
                            {digit}
                        </span>
                    ))}
                    <span className={styles.unit}>日</span>
                </div>
            </div>
        </div>
    );
};

BannerArt.propTypes = {
    isMarginTop: PropTypes.bool,
};

export default BannerArt;
